import {useState, useEffect} from 'react'
import {repositoryPath} from '@github-ui/paths'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

type RefsResponse = {
  refs: string[]
}

export function useBranches(owner: string, repo: string): string[] {
  const [branches, setBranches] = useState<string[]>([])

  useEffect(() => {
    if (!owner || !repo) return

    let cancelled = false

    const fetchBranches = async () => {
      try {
        const endpoint = `${repositoryPath({owner, repo, action: 'refs'})}?type=branch`

        const response = await verifiedFetchJSON(endpoint)
        if (cancelled || !response.ok) return

        const json = (await response.json()) as RefsResponse
        if (!cancelled) {
          setBranches((json.refs ?? []).filter((ref): ref is string => typeof ref === 'string'))
        }
      } catch {
        // Silently fail - branches filter just won't appear
      }
    }

    fetchBranches()
    return () => {
      cancelled = true
    }
  }, [owner, repo])

  return branches
}
